var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forms",attrs:{"autocomplete":_vm.autocomplete}},[_vm._t("default"),_c('div',{staticClass:"bottom-form--fix"},[_vm._t("bottom")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }